import { gql } from '@apollo/client';

export const DELETE_FACILITY = gql`
    mutation deleteFacilityWithVerifyCode($facilityDetails: DeleteFacility!) {
        company {
            facility {
                delete(input: $facilityDetails)
            }
        }
    }
`;
